import { render, staticRenderFns } from "./ProjectDocumentsSection.vue?vue&type=template&id=683efc4c&scoped=true&"
import script from "./ProjectDocumentsSection.vue?vue&type=script&lang=js&"
export * from "./ProjectDocumentsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683efc4c",
  null
  
)

export default component.exports